import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Clock from "./Clockhooks";
import "./Clock.css";

//test git remote access

ReactDOM.render(
  <React.StrictMode>
    <Clock />
  </React.StrictMode>,
  document.getElementById("root")
);
